import { configure, makeAutoObservable } from "mobx";
import { fetchDesignHTML } from "../services/DesignService";

configure({
  enforceActions: "never",
})

class ViewStore {
  constructor() {
    makeAutoObservable(this);
  }
  designId = null
  designHTML = null
  title = ''
  errors = null
  isMobile = false
  dimensions = {
    width: 0,
    height: 0
  }

  checkIfMobileView(){
    if(window.innerWidth < 850){
      this.isMobile = true
    }else{
      this.isMobile = false
    }
  }

  async setDesignId(){
    const vals = window.location.pathname.split('/')
    let id = vals[vals.length - 1]
    if(id === 'view' || id === ''){
      id = vals[vals.length - 2]
    }
    try{
      const data = await fetchDesignHTML(id)
      this.designHTML = data.html
      this.title = data.title
      this.dimensions = data.dimensions
      if(data.fonts.length){
        data.fonts.forEach(fontStyle => {
          const styleEl = document.createElement('style')
          styleEl.innerText = fontStyle
          document.head.append(styleEl)
        })
      }
    }catch(err){
      console.log(err)
    }
  }
}

export default new ViewStore